import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import ListItem from '../presents/ListItem'
import { NEWSPAPER_DATA } from '../../../constants/state'
import getData from '../../../functions/getData'

const mapStateToProps = state => ({
    newspaperData: getData(state, NEWSPAPER_DATA)
})

const ListItemBottomItemNewspaperContainer = ({
    itemType,
    itemData, 
    isSelected,
    onDelete,
    textKey,
    pathnameEdit,
    newspaperData
}) => {
    const bottomItemData = newspaperData.customItems.items ? newspaperData.customItems.items[itemData.id] : null
    const text = bottomItemData[textKey] ? bottomItemData[textKey] : false
    
    if(!itemData || !itemData.id) {
        return ''
    } else {
        return <ListItem
            title={text}
            styles={false}
            type={itemType}
            isSelected={isSelected}
            pathnameEdit={pathnameEdit}
            onDelete={onDelete}
        />
    }
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ListItemBottomItemNewspaperContainer)